import axios from 'axios';
import { getAuthorizationHeaders, authenticationFailureInterceptor } from '../../authentication/authenticationHelpers';

const firebaseServiceClient = axios.create({
    baseURL: process.env.VUE_APP_FIREBASE_PROXY_BASE_URL,
    timeout: 30000,
});

firebaseServiceClient.interceptors.response.use(undefined, (error) => authenticationFailureInterceptor(error));

const defaultState = {
    firebaseProjects: null,
    gcpProjects: null,
    firebaseProject: null,
    androidApp: null,
    iosApp: null,
    sha: null,
};

const getters = {
    gcpProjects: (state) => state.gcpProjects,
    firebaseProjects: (state) => state.firebaseProjects,
    firebaseProject: (state) => state.firebaseProject,
    androidApp: (state) => state.androidApp,
    iosApp: (state) => state.iosApp,
    sha: (state) => state.sha,
};

const actions = {
    async list(context, { type }) {
        const mutation = type === 'gcp' ? 'setGcpProjects' : 'setFirebaseProjects';
        context.commit(mutation, null);
        const config = getAuthorizationHeaders(context.rootState.authentication.token, context.rootState.authentication.access_token);
        const { data: { projects } } = await firebaseServiceClient.get(`projects?type=${type}`, config);
        context.commit(mutation, projects);
    },
    async createFirebaseProject(context, { form, project }) {
        const config = getAuthorizationHeaders(context.rootState.authentication.token, context.rootState.authentication.access_token);
        try {
            context.commit('setFirebaseProject', { buildStatus: 'inProgress' });
            const response = await firebaseServiceClient.post(
                `projects?gcpId=${project.id}`,
                form.firebaseProject,
                config
            );
            context.commit('setFirebaseProject', { ...response.data, buildStatus: 'success' });
        } catch (error) {
            console.log(error);
            context.commit('setFirebaseProject', { buildStatus: 'error' });
        }
    },
    async addAndroidApp(context, { form, firebaseProject }) {
        const config = getAuthorizationHeaders(context.rootState.authentication.token, context.rootState.authentication.access_token);
        context.commit('setAndroidApp', { buildStatus: 'inProgress' });
        if (firebaseProject.buildStatus === 'success') {
            try {
                const response = await firebaseServiceClient.post(
                    `apps?projectId=${firebaseProject.id}&displayName=${firebaseProject.displayName}`,
                    { apps: [form.androidApp] },
                    config
                );
                context.commit('setAndroidApp', { ...response.data.apps[0], buildStatus: 'success' });
            } catch (error) {
                context.commit('setAndroidApp', { buildStatus: 'error' });
            }
        } else {
            context.commit('setAndroidApp', { buildStatus: 'error' });
        }
    },
    async addIosApp(context, { form, firebaseProject }) {
        const config = getAuthorizationHeaders(context.rootState.authentication.token, context.rootState.authentication.access_token);
        context.commit('setIosApp', { buildStatus: 'inProgress' });
        if (firebaseProject.buildStatus === 'success') {
            try {
                const response = await firebaseServiceClient.post(
                    `apps?projectId=${firebaseProject.id}&displayName=${firebaseProject.displayName}`,
                    { apps: [form.iosApp] },
                    config
                );
                context.commit('setIosApp', { ...response.data.apps[0], buildStatus: 'success'  });
            } catch (error) {
                context.commit('setIosApp', { buildStatus: 'error' });
            }
        } else {
            context.commit('setIosApp', { buildStatus: 'error' });
        }
    },
    async addSha(context, { form, androidApp }) {
        const config = getAuthorizationHeaders(context.rootState.authentication.token, context.rootState.authentication.access_token);
        context.commit('setSha', { buildStatus: 'inProgress' });
        if (androidApp.buildStatus  === 'success') {
            try {
                const response = await firebaseServiceClient.post(
                    `shas?projectId=${androidApp.projectId}&appId=${androidApp.appId}`,
                    form.androidApp.sha,
                    config
                );
                context.commit('setSha', { ...response.data, buildStatus: 'success' });
            } catch(error) {
                context.commit('setSha', { buildStatus: 'error' });
            }
        } else {
            context.commit('setSha', { buildStatus: 'error' });
        }
    },
    async resetBuildResult(context) {
        context.commit('setFirebaseProject', null);
        context.commit('setAndroidApp', null);
        context.commit('setIosApp', null);
        context.commit('setSha', null);
    },
};

const mutations = {
    setGcpProjects(state, projects) {
        state.gcpProjects = projects;
    },
    setFirebaseProjects(state, firebaseProjects) {
        state.firebaseProjects = firebaseProjects;
    },
    setFirebaseProject(state, firebaseProject) {
        state.firebaseProject = firebaseProject;
    },
    setAndroidApp(state, androidApp) {
        state.androidApp = androidApp;
    },
    setIosApp(state, iosApp) {
        state.iosApp = iosApp;
    },
    setSha(state, sha) {
        state.sha = sha;
    },
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    actions,
    mutations,
};
